import { AuthService } from '../services/auth.service';
export interface IAspNetRoles{
    Id:string;
    Ten:string;
    Name:string;
    TrangThai:number;
    IdCoQuan:number;
    Ids:string;

}

export class AspNetRoles implements IAspNetRoles{
    Id:string="";
    Name:string="";
    Ten:string="";
    TrangThai:number=1;
    IdCoQuan:number=0;
    Ids:string="";

    constructor(values: Object = {}) {
        
        Object.assign(this, values);
    }
}

export class SearchAspNetRoles{
    keyword:string = "";
    maxSize:number = 3;
    
}

export class UserByRole{
    UserId:string = '';
    Email:string = '';
    UserName:string = '';
    HoTen:string = '';
    IDDonVi:number = 0;
    TenDonVi:string = '';
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/asp-net-roles/asp-net-roles.ts